import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['totalPoint', 'fee1', 'fee2', 'fee3', 'fee4', 'fee5', 'fee6', 'fee7', 'fee8', 'fee9', 'fee10', 'fee11','fee12','form']
  static classes = []
  static values = {}

  connect() {
    this.confirmed = false;
    this.calculateTotalPoint()
  }

  changeFeeItem() {
    this.calculateTotalPoint()
  }

  calculateTotalPoint() {
    const fee1 = parseInt(this.fee1Target.value) || 0
    const fee2 = parseInt(this.fee2Target.value) || 0
    const fee3 = parseInt(this.fee3Target.value) || 0
    const fee4 = parseInt(this.fee4Target.value) || 0
    const fee5 = parseInt(this.fee5Target.value) || 0
    const fee6 = parseInt(this.fee6Target.value) || 0
    const fee7 = parseInt(this.fee7Target.value) || 0
    const fee8 = parseInt(this.fee8Target.value) || 0
    const fee9 = parseInt(this.fee9Target.value) || 0
    const fee10 = parseInt(this.fee10Target.value) || 0
    const fee11 = parseInt(this.fee11Target.value) || 0
    const fee12 = parseInt(this.fee12Target.value) || 0
    this.totalPointTarget.textContent = fee1 + fee2 + fee3 + fee4 + fee5 + fee6 + fee7 + fee8 + fee9 + fee10 - fee11 + fee12
  }

  buttonDisabled(event){
    const el = event.currentTarget;
    el.disabled = true;
    if (el.name == "save_and_billed_button"){
      this.confirmed = true;
      const sab = document.getElementById("save_and_billed");
      sab.disabled = false;
    }
    if (el.name == "save_and_sales_confirmed_button"){
      const sab = document.getElementById("save_and_sales_confirmed");
      sab.disabled = false;
    }
    if (el.name == "save_and_calculate_waiting_button"){
      const sab = document.getElementById("save_and_calculate_waiting");
      sab.disabled = false;
    }
    const payment_link_required = document.getElementById("payment_link_required");
    if (payment_link_required.value == "true"){
      const payment_link = document.getElementById("payment_link");
      if(payment_link.value == "" || payment_link.value == null){
        document.getElementById("payment_link_error").style.display = "block";
        this.confirmed = false;
      }else{
        document.getElementById("payment_link_error").style.display = "none";
        this.confirmed = true;
      }
    }
    if (this.confirmed == true){
      this.formTarget.submit();
    }else{
      el.disabled = false;
    }
  }

  confirmDialog(event){
    const params = event.params;
    const confirmed = confirm(params.confirm);
    if (!confirmed){
      event.preventDefault();
    }else{
      this.confirmed = true;
    }
  }
}
